// format the date to human readable format
export const formatDatewithTime = (inputDate) => {
  if (inputDate == null) {
    return "";
  }

  const adjustedDateString = inputDate.replace(/([+-]\d{2}:\d{2})$/, "");
  // Parse the adjusted date string
  const date = new Date(adjustedDateString);
  const offset = date.getTimezoneOffset() * 60000; // Offset in milliseconds
  const adjustedDate = new Date(date.getTime() - offset);

  // Format the date to "Jul 25, 2024, 1:08 PM"
  const options = {
    year: "numeric",
    month: "short",
    day: "numeric",
    hour: "numeric",
    minute: "numeric",
    hour12: true,
  };

  return adjustedDate.toLocaleString("en-US", options);
};

export function convertTimestampToCustomFormat(timestamp) {
  const stringifyTimepstamp = timestamp;
  const year = stringifyTimepstamp.slice(0, 4);
  const month = stringifyTimepstamp.slice(4, 6);
  const day = stringifyTimepstamp.slice(6, 8);
  const hour = parseInt(stringifyTimepstamp.slice(8, 10)) + 8;
  const minute = stringifyTimepstamp.slice(10, 12);
  const second = stringifyTimepstamp.slice(12, 14);

  // Define an array to map month numbers to month names
  const monthNames = [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec",
  ];

  // Convert month to the corresponding month name
  const monthName = monthNames[parseInt(month, 10) - 1];

  // Convert 24-hour format to 12-hour format with "am" or "pm"
  let ampm = "am";
  let hour12 = hour;
  if (hour12 >= 12) {
    ampm = "pm";
    if (hour12 > 12) {
      hour12 -= 12;
    }
  }

  // Construct the formatted date string
  const formattedDate = `${monthName} ${day}, ${year} ${hour12}:${minute}${ampm}`;

  return formattedDate;
}

export function formatDate(inputDate) {
  const options = {
    year: "numeric",
    month: "short",
    day: "numeric",
  };
  const date = new Date(inputDate);
  return date.toLocaleDateString("en-US", options).toString() == "Invalid Date"
    ? ""
    : date.toLocaleDateString("en-US", options);
}

export const formatCurrencyValue = (value, currency = "PHP") => {
  const number = parseFloat(value);
  if (isNaN(number)) return value;

  const formatted = number.toLocaleString("en-PH", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });

  return currency === "PHP" ? `₱ ${formatted}` : `${formatted} MBOX`;
};

export function combineDateAndTime(dateString, timeString) {
  // Combine date and time strings into a single string
  const combinedString = `${dateString}T${timeString}:00`;

  // Create a Date object from the combined string
  const combinedDateTime = new Date(combinedString);

  // Get the ISO 8601 format string with time and timezone
  const isoString = combinedDateTime.toISOString();

  // Remove milliseconds and return the formatted string
  return isoString.slice(0, -5) + "Z";
}

export const toUTCDateTimeString = (date, time = "00:00") => {
  const [hours, minutes] = time.split(":");

  // Create a new date to avoid mutating the original
  const newDate = new Date(date);

  // Set the time in local timezone
  newDate.setHours(parseInt(hours, 10), parseInt(minutes, 10), 0, 0);

  // **KEY FIX: Convert from Philippine Time (UTC+8) to UTC by subtracting 8 hours**
  const utcDate = new Date(newDate.getTime() - 8 * 60 * 60 * 1000);

  // Format the date components manually to avoid timezone conversion
  const year = utcDate.getFullYear();
  const month = String(utcDate.getMonth() + 1).padStart(2, "0");
  const day = String(utcDate.getDate()).padStart(2, "0");
  const hour = String(utcDate.getHours()).padStart(2, "0");
  const minute = String(utcDate.getMinutes()).padStart(2, "0");

  return `${year}-${month}-${day} ${hour}:${minute}:00.000+00:00`;
};
